import React, { createRef } from "react";
import { getAppState, withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { i18n } from "../../services/i18nService";
import { redirectTo } from "../../services/navigationService";
import { historyMethods } from "../../utils/historyMethods";
import { getPreferredLanguage } from "../../utils/perferedLanguage";
import { routes } from "../../routes";
import {
  PageWrapper,
  MainWrapper,
  InputFieldContainer,
  InputDigit,
  MainHeading,
  HeadingText,
  MainViewContainer,
  LogoStyled,
  ButtonsGroupStyled,
  KeyButtonStyledCancel,
  KeyButtonStyledContinue,
  FooterStyled,
  ErrorHeadingText,
  ImageDefaultStyled
} from "./styles/Styled";
import { withFocusable, NumericKeyboard, Loading } from "../../services/visualLibraryService";
import FreeLogo from "../../components/FreeLogo";
import {
  createProfilePin,
  getUpdatedProfile,
  verifyProfilePin,
  updateCurrentProfileInIndexDB,
  getCurrentProfile
} from "../../services/multipleProfilesService";
import { getSdk } from "../../services/sdkService";
import { showSaveProfileChangesModal } from "../../utils/multiProfileModalUtils";
import { trackEvent } from "../../services/analyticsService";

const KeyButtonStyledCancelFocus = withFocusable(KeyButtonStyledCancel);
const KeyButtonStyledContinueFocus = withFocusable(KeyButtonStyledContinue);

const MP = "MP";
const STRING = "string";
const TYPE_SETUP_PASSWORD = "text";
const descriptionSubtextAdults = "description2";
const descriptionSubtextKids = "descriptionKids";
const DEFAULT_IMAGE = "/images/background-3.png";
class PinLock extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      otp: new Array(4).fill(""),
      index: 0,
      setupProfile: true,
      isWrongPinEntered: false,
      isLoaded: true
    };
    this.inputRefs = Array.from({ length: 4 }).map(() => createRef());
    this.updateValue = this.updateValue.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this.onDiscardChanges = this.onDiscardChanges.bind(this);
    this.goingBack = this.goingBack.bind(this);
    this.onBack = this.onBack.bind(this);
    this.resetValuesOnProfileChange = this.resetValuesOnProfileChange.bind(this);
    this.isSaveChangesModalOpen = false;
    this.currentProfile = null;
  }

  updateValue(value) {
    if (this.state.isWrongPinEntered) {
      this.setState({ isWrongPinEntered: false });
    }
    const { index, otp } = this.state;
    if (!isNaN(value) && index <= otp.length - 1) {
      this.setState(
        prevState => {
          const updatedOTP = prevState.otp.map((d, idx) => (idx === index ? value : d));
          return { otp: updatedOTP };
        },
        () => {
          if (this.state.otp.indexOf("") === -1) {
            this.props.setFocus("loginNextButton");
          }
        }
      );
      this.setState({ index: index + 1 });
    } else {
      if (typeof value === STRING) {
        otp[index - 1] = "";
        this.setState({ index: index > 0 ? index - 1 : index });
      }
    }
  }

  async componentDidMount() {
    const { onRef } = this.props;
    onRef && onRef(this);
    this.mounted = true;
    const { history } = this.props;
    this.currentProfile = await getCurrentProfile();
    const hasHistoryState = !!(history.location && history.location.state);
    if (hasHistoryState) {
      const {
        state: { isVerifyPin, profileName, profileData }
      } = this.props.history.location;
      const isKids = profileData.profileCategory === "KIDS" ? true : false;
      this.setState({
        profileName: profileName,
        setupProfile: !isVerifyPin,
        descriptionSubtext: isKids ? descriptionSubtextKids : descriptionSubtextAdults
      });
    }
  }

  async componentWillUnmount() {
    this.mounted = false;
  }

  async saveChanges() {
    const {
      state: {
        isVerifyPin,
        createPin,
        profileId,
        fromProfileSelector,
        profileData,
        fromNavbar,
        nextPageReference,
        deepLinkReferrer
      }
    } = this.props.history.location;
    const { stateActions } = this.props;
    const { otp } = this.state;
    const requestData = { profileId, pin: otp.join("").toString() };
    if (isVerifyPin) {
      const response = await verifyProfilePin(requestData);
      if (response !== 200) {
        trackEvent("profile_pin_failed", null, MP, profileData);
        this.props.setFocus("key_1");
        this.setState({
          isWrongPinEntered: true,
          otp: new Array(4).fill(""),
          index: 0
        });
        return;
      }
      if (response === 200 && fromProfileSelector) {
        trackEvent("profile_pin_success", null, MP, profileData);
        stateActions.setCurrentProfileId(profileData?.profileId);
        await updateCurrentProfileInIndexDB({ ...profileData, isGenerateJWTToken: true });
        this.props.applicationState.preferredLanguage = await getPreferredLanguage();
        this.setState({ isLoaded: false }, async () => {
          this.resetValuesOnProfileChange(profileData);
          redirectTo.call(
            this,
            nextPageReference,
            deepLinkReferrer ? { deepLinkReferrer: true } : null,
            historyMethods.REPLACE
          );
          this.setState({ isLoaded: true });
        });
      } else if (response === 200 && fromNavbar) {
        trackEvent("profile_pin_success", null, MP, profileData);
        redirectTo.call(this, routes.profileSelector, null, historyMethods.PUSH);
      }
    } else if (createPin) {
      const response = await createProfilePin(requestData);
      if (response === 200) {
        const updatedProfileData = await getUpdatedProfile(profileId, getAppState().country);
        const updatedProfile = {
          location: this.isSaveChangesModalOpen ? "back discard popup" : "manage profile screen",
          isProfileLockChange: true
        };
        trackEvent("profile_settings_updated", null, "MP", {
          profileData: { updatedProfileId: updatedProfileData?.profileId, ...updatedProfileData },
          updatedProfile
        });
        trackEvent("profile_pin_changed", null, MP, updatedProfileData);
        this.isSaveChangesModalOpen = false;
        redirectTo.call(this, routes.settings, null, historyMethods.REPLACE);
      }
      // response === 200 && this.props.history.goBack();
    }
  }

  async resetValuesOnProfileChange(selectedItem) {
    const sdk = await getSdk();
    await sdk.mediaManager.clearLayoutCache();
    await sdk.userManager.setLanguage(selectedItem.language);
    this.props.stateActions.setLocale(selectedItem.language);
    localStorage.setItem("parentalLevel", selectedItem.parentalControl);
    localStorage.setItem("locale", selectedItem.language);
  }

  onBack() {
    const { setupProfile, otp } = this.state;
    if (setupProfile && otp?.join("")?.toString().length === 4) {
      this.isSaveChangesModalOpen = true;
      return showSaveProfileChangesModal.call(this, this.saveChanges, this.onDiscardChanges);
    }
    this.goingBack();
  }

  onDiscardChanges() {
    const profileData = this.props.history.location.state.profileData;
    this.isSaveChangesModalOpen = false;
    trackEvent("profile_settings_update_discarded", null, "MP", { location: "back discard popup", ...profileData });
    this.props.stateActions.hideGlobalModal();
    this.goingBack();
  }

  goingBack() {
    const { history, stateActions } = this.props;
    const hasHistoryState = !!(history.location && history.location.state);
    if (hasHistoryState && history.location.state.backDestination) {
      const backDestination = history.location.state.backDestination;
      const profileData = history.location.state.profileData;
      const backDestinationPathname = backDestination.pathname || backDestination;
      const popup = history.location.state.popup || false;

      trackEvent("profile_pin_cancel_click", null, MP, profileData);
      if (!this.currentProfile) {
        stateActions.setCurrentProfileId("");
      }
      history.replace({
        pathname: backDestinationPathname,
        state: {
          profileData: { ...profileData },
          backDestination: routes.settings,
          nextPage: routes.pinLock,
          popup: popup
        }
      });
      return true;
    }
    history.goBack();
    return true;
  }

  render() {
    const { otp, index, profileName, setupProfile, isWrongPinEntered, descriptionSubtext, isLoaded } = this.state;
    return isLoaded ? (
      <div>
        <ImageDefaultStyled src={DEFAULT_IMAGE} alt="" width={"100%"} />
        <PageWrapper direction={i18n.getDirection()}>
          <LogoStyled direction={i18n.getDirection()}>
            <FreeLogo height={"1.968rem"} />
          </LogoStyled>
          <MainWrapper>
            <MainHeading>
              {i18n.get("global.welcome")} {profileName}!
            </MainHeading>
            {isWrongPinEntered ? (
              <ErrorHeadingText>{i18n.get("pages.pinLock.error")}</ErrorHeadingText>
            ) : (
              <HeadingText>
                {this.props.history.location.referrer === "/profile-selector"
                  ? i18n.get("pages.profileSelector.lockedProfile.adult.subHeading")
                  : setupProfile
                  ? i18n.get(`pages.pinLock.${descriptionSubtext}`)
                  : i18n.get("pages.pinLock.description1")}
              </HeadingText>
            )}
            <InputFieldContainer direction={i18n.getDirection()}>
              {otp.map((data, index) => (
                <InputDigit
                  key={index}
                  ref={this.inputRefs[index]}
                  type={TYPE_SETUP_PASSWORD}
                  placeholder="__"
                  maxLength="1"
                  value={!setupProfile && data !== "" ? "*" : data}
                />
              ))}
            </InputFieldContainer>
            <MainViewContainer>
              <NumericKeyboard text={Number(otp[index])} onChange={this.updateValue} />
            </MainViewContainer>
            <ButtonsGroupStyled>
              <KeyButtonStyledCancelFocus
                focusPath={"loginBackButton"}
                onEnterPress={this.onBack}
                onMouseUp={this.onBack}
              >
                {i18n.get("global.cancel")}
              </KeyButtonStyledCancelFocus>
              <KeyButtonStyledContinueFocus
                focusPath={"loginNextButton"}
                onMouseUp={this.saveChanges}
                onEnterPress={this.saveChanges}
                disabled={!(otp.indexOf("") === -1)}
              >
                {i18n.get("global.continue")}
              </KeyButtonStyledContinueFocus>
            </ButtonsGroupStyled>
            {!setupProfile && (
              <FooterStyled direction={i18n.getDirection()}>{i18n.get("pages.pinLock.footer")}</FooterStyled>
            )}
          </MainWrapper>
        </PageWrapper>
      </div>
    ) : (
      <Loading overlay />
    );
  }
}

const Component = withAppState(withSubtheme(PinLock));

export default Component;
